var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "white",
    stroke: "#FF00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7645 9.24782C24.2838 8.76716 23.5074 8.76716 23.0267 9.24782L17 15.2622L10.9733 9.23549C10.4926 8.75484 9.71615 8.75484 9.23549 9.23549C8.75484 9.71615 8.75484 10.4926 9.23549 10.9733L15.2622 17L9.23549 23.0267C8.75484 23.5074 8.75484 24.2838 9.23549 24.7645C9.71615 25.2452 10.4926 25.2452 10.9733 24.7645L17 18.7378L23.0267 24.7645C23.5074 25.2452 24.2838 25.2452 24.7645 24.7645C25.2452 24.2838 25.2452 23.5074 24.7645 23.0267L18.7378 17L24.7645 10.9733C25.2328 10.5049 25.2328 9.71616 24.7645 9.24782Z",
    fill: "#FF00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.31c26af85e0fc2376bdbdf5e3f61dcf9.svg";
export { ForwardRef as ReactComponent };